import { Container, Typography } from "@mui/material";
import DashboardLayout from "../../layouts/DashboardLayout";

import useStyles from "./styles";

const Help = () => {
  const classes = useStyles();

  return (
    <DashboardLayout>
      <Container className={classes.container}>
        <Typography variant="h4" component="h4">
          Help
        </Typography>
      </Container>
    </DashboardLayout>
  );
};

export default Help;
